<template>
  <div
    class="opple-config-platform"
  >
    <TopBar
      ref="Platform"
      :device="device"
      :is-delete-loading="isDeleteLoading"
      @selectAll="selectAll"
      @showDeviceDialog="showDeviceDialog"
      @deleteDevice="onDeleteDevice"
    />
    <div
      class="opple-config-platform_list"
    >
      <i
        v-if="isAddLoading"
        class="el-icon-loading"
      />
      <div
        v-if="!isAddLoading && deviceCardList.length === 0"
        class="opple-config-platform_list-noData"
      >
        <img :src="noData">
        <p>{{ $t('adddevice.noDevice') }}</p>
      </div>
      <template v-if="!isAddLoading && deviceCardList.length !== 0">
        <OppleDeviceCard 
          v-for="(card, index) in deviceCardList"
          :key="card.VDeviceId"
          :data="card"
          :select-type="selectType"
          @select="onSelect"
        />
      </template>
    </div>
    <el-dialog
      :visible="isDeviceDialogVisable"
      class="dialogGroup choose_device"
      :before-close="handlerClose"
      top="0"
      append-to-body
    >
      <op-device-choose
        v-if="isDeviceDialogVisable"
        ref="opDeviceChoose"
        class="content"
        :is_group="false"
        :areaid="gpNo"
        :area-tree-type="1"
        :execute-type="2"
        :displaynoarea="true"
        :triggledevice="true"
        :is-ifttt="true"
        :device-category-type="524290"
        :checkeddata="checkeddata"
        :get-device-list-fn="getDeviceListFn"
        @confirm="deviceValueChange"
      />
    </el-dialog>
  </div>
</template>

<script>
import OppleDeviceCard from '@/components/OppleDeviceCard/index.vue';
// import OpDeviceChoose from '@/components/common/OpDeviceChoose.vue';
import TopBar from './TopBar.vue';
import noData from '@/assets/img/no-data.png';
import { AddDeviceRelation, GetRelationDeviceList, RemoveDeviceRelation, GetDeviceListByPage } from "@/axios/IMonitor.js";
import { alerterror } from '@/assets/js/common.js';

export default {
  name: 'OppleConfigPlatform',
  components: {
    OppleDeviceCard,
    // OpDeviceChoose,
    TopBar
  },
  props: {
    selectType: {
      type: Number,
      default: 1
    },
    device: {
      type: Object,
      default: () => ({})
    },
    relationAction: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: Number,
      default: 1
    },
    gpConfig: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkeddata: [],
      gpNo: -1,
      currentTab: 0,
      isAddLoading: false,
      isDeleteLoading: false,
      isDeviceDialogVisable: false,
      deviceCardList: [],
      noData,
      RelationClassSkuParams: [],
      CatParams: [],
      SubCatParams: [],
      MaxCount: null
    };
  },

  computed: {},

  watch: {
    device(value) {
      this.requestRelationDeviceList();
      // this.setCom();
    },
    activeTab(value) {
      this.init();
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    init () {
      const relationConfig = (this.relationAction[this.activeTab] || {
        ParamsConfigMap: {}
      }).ParamsConfigMap.RelationInfo;

      this.RelationClassSkuParams = relationConfig.RelationClassSku;

      const list = this.gpConfig.reduce((pre, next) => {
        return pre.concat(next.GpDetails || []);
      },  []);

      const config = list.find(item => item.KeyId === relationConfig.KeyId);

      if (config) {
        const DefaultValue =  config[relationConfig.ValuePath] || '{}';

        try {
          const defaultValue = JSON.parse(DefaultValue);
          const curValue = defaultValue.find(item => item.Type === relationConfig.RelationType)
          const curSub =  curValue.Sub.find(item => item.Id === relationConfig.SubId);

          this.CatParams = curSub.Cat;
          this.SubCatParams = curSub.SubCat;
          this.MaxCount = curSub.Max;
        } catch (e) {
          console.log('relationConfig e', e);
          
        }
      }

      console.log('relationConfig', relationConfig, this.gpConfig, config);
      this.requestRelationDeviceList();
    },
  
    async requestRelationDeviceList() {
      try {
        const res = await GetRelationDeviceList({
          DeviceId: this.device.DeviceId,
          ChildCategoryTypeList: this.CatParams,
          SubDeviceTypeList: this.SubCatParams
        });

        const list = (res.Result || []).map(item => {
          const info = item.StatusInfo || '{}';
          return {
            ...item,
            StatusInfo: JSON.parse(info),
            isCheck: false
          }
        });

        this.deviceCardList = list;
        // 不选择这个设备本身 因为设备不能关联自己
        this.checkeddata = [...list, Object.assign({}, this.device)];
      } catch (e) {

      }
    },

    async getDeviceListFn(para,callback) {
      try {
        const res = await GetDeviceListByPage({
          gpNo: -1,
          deviceId: this.device.DeviceId,
          deviceCategoryType: this.SubCatParams.join(','),
          childCategoryType: this.CatParams.map(item => parseInt(item, 16)).join(','),
          classSku: this.RelationClassSkuParams.join(','),
          pageIndex: 1,
          pageSize: 888888,
        });

        const RecordList = (res.Result || {}).RecordList || [];

        callback({
          StatusCode: res.StatusCode,
          Result: {
            RecordList,
            PageCount: 1,
            PageIndex: 1,
            PageSize: 888888,
            PanelCount: 0,
            SensorCount: 0,
            GatewayCount: RecordList.length,
            TotalCount: RecordList.length,
          }
        }, {
          pageIndex: 1,
        });
        
      } catch (e) {

      }
    },
    
    onItemClick(tab) {
      this.currentTab = tab;
    },
  
    selectAll() {
      this.deviceCardList = this.deviceCardList.map((item) => ({ ...item, checked: true }))
    },
  
    onSelect(data, isCheck) {
      if (this.selectType === 1) {
        this.deviceCardList = this.deviceCardList.map((item) => {
          if (
            item.ClassSku === data.ClassSku &&
            item.VDeviceId === data.VDeviceId
          ) {
            return {
              ...item,
              checked: isCheck
            }
          }

          return {
            ...item,
            // checked: !!isCheck ? false : item.checked
          }
        })
      }
      console.log('data', data, isCheck, this.deviceCardList);
    },
    showDeviceDialog() {
      if (Number.isInteger(this.MaxCount) && this.MaxCount === this.deviceCardList.length) {
        this.$message({
          type: "warning",
          message: this.$t('ifttt.createUp3').replace(/\${{n}}/, this.MaxCount)
          // `最多${this.MaxCount}条`, // this.$t('ifttt.createUp3')
        })
  
        return;
      }

      this.isDeviceDialogVisable = true;
    },
    handlerClose() {
      this.isDeviceDialogVisable = false;
    },

    async deviceValueChange(devlices) {
      if (Number.isInteger(this.MaxCount) && this.MaxCount < (this.deviceCardList.length + devlices.length)) {
        this.$message({
          type: "warning",
          message: this.$t('ifttt.createUp3').replace(/\${{n}}/, this.MaxCount)
        })
  
        return;
      }

      const relativeDevices = devlices.map(device => ({
        RelationId: device.DeviceId,
        DeviceId: this.device.DeviceId,
        UserFavoritesType: 1,
        ChildCategoryTypeList: this.CatParams,
        SubDeviceTypeList: this.SubCatParams
      }));

      try {
        this.isAddLoading = true;

        this.handlerClose();

        const res = await AddDeviceRelation(relativeDevices);

        console.log('eeee 1', res);

        if (res.StatusCode !== this.$store.state.rightStatusCode) {
          alerterror(this, res.StatusCode);
        }

        await this.requestRelationDeviceList();

        this.isAddLoading = false;
      } catch (e) {
        console.log('eeee', e);
        
        this.isAddLoading = false;
        this.$message({
          type: "warning",
          message: e.Message
        })
      }
      // console.log('devlices', relativeDevices);
    },

    async onDeleteDevice() {
      // 排除设备自己
      const checkeddata = this.deviceCardList.filter(device => !!device.checked).filter(
        device => device.ChildId !== this.device.ChildId || 
          device.ClassSku !== this.device.ClassSku ||
          device.DeviceId !== this.device.DeviceId ||
          device.VDeviceId !== this.device.VDeviceId
        )

      const req = checkeddata.map(device => ({
        RelationId: device.DeviceId,
        DeviceId: this.device.DeviceId,
        UserFavoritesType: 1
      }));

      try {
        this.isDeleteLoading = true;
        
        const res = await RemoveDeviceRelation(req);

        await this.requestRelationDeviceList();

        this.isDeleteLoading = false;
      } catch (e) {
        this.isDeleteLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.opple-config-platform {
  flex: 1;

  &_list {
    display: flex;
    flex-wrap: wrap;

    &-noData {
      margin: 0 auto;
      width: 280px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #9E9E9E;
  
      img {
        width: 100%;
        margin-bottom: 10px;
      }
    }

    .el-icon-loading {
    margin: 10px 100px;
  }
  }

  .opple-device-card {
    margin: 10px;
  }
}

</style>